<template>
    <div >
        <DesignButton 
            :btnText="buttonText" btnSize="LG" btnType="QUATERNARY" :btnDisabled="false"
            @click-event="openPopupReportSelectOption" 
        />
    </div>
    <Teleport to="body">
        <AppPopup id="popup-select-report-down-option"
            v-model="openSelectDownOption" :buttonText="'Download'" :name="popupTitle" :buttonCenter="true" @buttonEvent="clickDownloadExcelOnPopup">
            <div class="my-10 mx-10">
                <label class="flex gap-4 justify-start items-center" id="single-select-emp">
                    <input type="radio" v-model="downloadEmpOption" :value="empSelectOptions.ONE" id="single-select-emp">
                    <ElementsButtonCard :hasClickEvent="false" buttonText="This Employee" :errorMsg="false" :selected="(downloadEmpOption==empSelectOptions.ONE)"/>
                </label>
                <label class="flex gap-4 justify-start items-center mt-3" id="all-select-emp">
                    <input type="radio" v-model="downloadEmpOption" :value="empSelectOptions.ALL" id="all-select-emp">
                    <ElementsButtonCard :hasClickEvent="false" buttonText="All Employees" :errorMsg="false" :selected="(downloadEmpOption==empSelectOptions.ALL)"/>
                </label>
                <label class="flex gap-4 justify-start items-center mt-3" id="multi-select-emp">
                    <input type="radio" v-model="downloadEmpOption" :value="empSelectOptions.MULTI" id="multi-select-emp">
                    <ElementsButtonCard 
                        :hasClickEvent="true" buttonText="Select Employees" :optionCount="empListToDownload.length" :showErrorMsg="downloadValidation"
                        @onClickButtonCard="openPopupSelectEmployee" :useBorder="true" :selected="(downloadEmpOption==empSelectOptions.MULTI)"
                        errorText="Please select at least one employee."
                    />
                </label>
            </div>
        </AppPopup>
        <SelectEmployeePopup 
            v-model="openSelectEmployee" :employeeList="employeeList" :emptyOption="true"
            :show-work-schedule-option="false" :show-department-option="true" :show-job-title-option="true"
            :useParentDepartmentOption="true" :useParentJobTitleOption="true" 
            :propDepartmentOption="departmentOptions" :propJobTitleOption="jobTitleOptions"
            :selectedList="empListToDownload" @save-employee="afterCloseSelectEmployee"  
            @onClickCancel="afterClickCancelSelectEmployee" :use-cancel-fn="true"
        />
    </Teleport>    
</template>

<script>
import DesignButton from '@/components/design-system/design-button.vue';
import AppPopup from '@/components/AppPopup.vue';
import ElementsButtonCard from '@/components/elements/ElementsButtonCard.vue';
import SelectEmployeePopup from '@/components/employee/select-employee-popup/select-employee-popup';

export default {
    components : {
        DesignButton, AppPopup, ElementsButtonCard, 
        SelectEmployeePopup
    },
    emits : [ "download-excel"],
    props : {
        buttonText : { type : String, default : "Download Excel" },
        popupTitle : { type : String, default : "Download Excel" },
        employeeList : Array,
        departmentOptions : Array,
        jobTitleOptions : Array,
        selectedOneEmployee : {
            type : Object, default : function(){ return { employeeSeq : "" }}
        }
    },
    data(){
        return {
            // download option 
            openSelectDownOption : false,
            openSelectEmployee : false,
            
            downloadValidation : false,
            
            empListToDownload : [],
            downloadEmpOption : null,
            empSelectOptions : { ONE : "ONE", ALL : "ALL" , MULTI : "MULTI" },

            scrollYBackup: 0
        }
    },
    computed: {
        // 여기에 모달이 더 있으면 || 로 추가
        isAnyPopupOpen() {
            return this.openSelectDownOption || this.openSelectEmployee;
        },
    },
    watch: {
        isAnyPopupOpen(val) {
            if (val) {
                this.lockBodyScroll();
            } else {
                this.unlockBodyScroll();
            }
        },
    },
    methods : {
        lockBodyScroll() {
            // 현재 스크롤 위치 저장
            this.scrollYBackup = window.scrollY || document.documentElement.scrollTop || 0;

            // 레이아웃 점프 방지 및 스크롤 잠금
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollYBackup}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden'; // 보조(데스크톱)
        },
        unlockBodyScroll() {
            // 원복
            const y = this.scrollYBackup || 0;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // 저장해 둔 위치로 복귀
            window.scrollTo(0, y);
        },
        openPopupReportSelectOption(){
            const self = this;
            self.openSelectDownOption = true;
            console.log( self.selectedOneEmployee );
            // init data  
            self.downloadEmpOption = self.empSelectOptions.ONE;
            self.downloadValidation = false;
            self.empListToDownload = [];
        },
        openPopupSelectEmployee(){
            const self = this;
            self.openSelectDownOption = false;
            self.downloadValidation = false;
            self.downloadEmpOption = self.empSelectOptions.MULTI;
            
            self.openSelectEmployee=true;
        },
        clickDownloadExcelOnPopup(){
            const self = this;
            if( (self.downloadEmpOption == self.empSelectOptions.MULTI) && (self.empListToDownload.length == 0) ){
                self.downloadValidation = true;
                return;
            }
            
            self.openSelectDownOption = false;
            const targetEmps = self.getEmpListToDownloadReport();
            self.$emit("download-excel", targetEmps );
            // self.clickDownExcel();
        },
        afterCloseSelectEmployee(list){
            const self = this;
            
            self.openSelectEmployee=false;
            self.openSelectDownOption = true; 
            self.empListToDownload = list.map(i=> i.employeeSeq);
        },
        afterClickCancelSelectEmployee(){
            const self = this;
            self.openSelectDownOption = true; 
        },
        getEmpListToDownloadReport(){
            const self = this;
            switch (self.downloadEmpOption) {
                case self.empSelectOptions.ONE:
                    return [ self.selectedOneEmployee.employeeSeq ];
                case self.empSelectOptions.ALL:
                    return self.employeeList.map(i=>i.employeeSeq);
                case self.empSelectOptions.MULTI:
                    return self.empListToDownload.map(e=> e);
                default:
                    return [];
            }
        },
    }
}

</script>
